import type { FormatLocale } from '#layers/base/public';
import type { CalendarEventSpan } from './calendar-events';
import { Temporal } from 'temporal-polyfill';
import { getDateTimeFormat, toNativeDate } from '#layers/base/public';
import { isSpanning, toPlainDate } from './calendar-events';

/** Returns null for a one-day date item, which callers show as All Day. */
export function formatCalendarEventTime({ start, end }: CalendarEventSpan, locale: FormatLocale): string | null {
	if (start instanceof Temporal.ZonedDateTime && end instanceof Temporal.ZonedDateTime) {
		const spansDays = isSpanning({ start, end });
		const formatter = getDateTimeFormat(locale, {
			...(spansDays && { month: 'short', day: 'numeric' }),
			hour: 'numeric',
			minute: '2-digit',
			timeZone: start.timeZoneId,
		});

		// Formats instants, since formatRange rejects ZonedDateTime values under native Temporal.
		if (Temporal.ZonedDateTime.compare(end, start) <= 0) return formatter.format(toNativeDate(start));
		return formatter.formatRange(toNativeDate(start), toNativeDate(end));
	}

	const firstDay = toPlainDate(start);
	const lastDay = toPlainDate(end);
	if (Temporal.PlainDate.compare(lastDay, firstDay) <= 0) return null;

	const formatter = getDateTimeFormat(locale, { month: 'short', day: 'numeric', timeZone: 'UTC' });
	return formatter.formatRange(toNativeDate(firstDay.toZonedDateTime('UTC')), toNativeDate(lastDay.toZonedDateTime('UTC')));
}
